import { forwardRef } from "react";
import { SelectorAvatar, SelectorAvatarStack } from "./selector-avatar";
import { SelectorPlaceholder, SelectorTrigger } from "./selector-trigger";
import type { AccountSelectSelection, SelectorTriggerProps } from "./types";

export interface AccountSelectProps extends SelectorTriggerProps {
  selection?: AccountSelectSelection;
  allLabel?: string;
}

export const AccountSelect = forwardRef<HTMLButtonElement, AccountSelectProps>(
  function AccountSelect(
    {
      selection,
      placeholder = "Select account",
      allLabel = "All accounts",
      size = "md",
      ...props
    },
    ref
  ) {
    return (
      <SelectorTrigger
        ref={ref}
        placeholder={placeholder}
        size={size}
        {...props}
      >
        {!selection ? (
          <SelectorPlaceholder>{placeholder}</SelectorPlaceholder>
        ) : selection.kind === "account" ? (
          <span className="flex min-w-0 items-center gap-2">
            <SelectorAvatar account={selection.account} size={20} />
            <span className="truncate text-neutral-800">
              {selection.account.label}
            </span>
          </span>
        ) : selection.kind === "group" ? (
          <span className="flex min-w-0 flex-1 items-center gap-1">
            <span className="truncate text-neutral-800">
              {selection.group.label}
            </span>
            <SelectorAvatarStack
              accounts={selection.group.accounts || []}
              max={4}
              size={20}
            />
          </span>
        ) : (
          <span className="truncate text-neutral-800">
            {selection.label || allLabel}
          </span>
        )}
      </SelectorTrigger>
    );
  }
);
